module.exports = __webpack_public_path__ + "static/cover-ade89bdca5e949451715a29535ee0d68.png";